import { NavigationItemType, NAVIGATION_ORDER } from '../constants/navigationConfig';
import { NavigationLink } from '../hooks/useNavigationLinks/types';

export interface NavigationMenu {
  id: string;
  links: NavigationLink[];
}

export interface MergedNavItem {
  id: string;
  type: NavigationItemType;
  order: number;
  data: NavigationLink | NavigationMenu | undefined;
}

export function mergeNavigationItems(
  links: NavigationLink[],
  menus: NavigationMenu[]
): MergedNavItem[] {
  const linksMap = new Map(links.map(link => [link.id, link]));
  const menusMap = new Map(menus.map(menu => [menu.id, menu]));

  return NAVIGATION_ORDER.reduce<MergedNavItem[]>((merged, config) => {
    if (config.type === NavigationItemType.LINK) {
      const link = linksMap.get(config.id);
      if (link) {
        merged.push({
          id: config.id,
          type: NavigationItemType.LINK,
          order: config.order,
          data: link,
        });
      }
    } else if (config.type === NavigationItemType.MENU) {
      const menu = menusMap.get(config.id);
      if (menu) {
        merged.push({
          id: config.id,
          type: NavigationItemType.MENU,
          order: config.order,
          data: menu,
        });
      }
    }

    return merged;
  }, []);
}
